import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useEffect } from "react";

import { useFormSubmit } from "./useFormSubmit";
import { useTransformValues } from "./useTransformValues";
import { useAdaptedFields } from "./useAdaptedFields";

import { fetchFields } from "../slices/getFieldsSlice";

import { sendForm } from "../slices/sendFormSlice";
import { clearForm } from "../slices/formSlice";

export const useDeparturesReportForm = () => {
    const dispatch = useDispatch();
    const formId = "reportForm";
    const token = useSelector((state) => state.auth.token);
    const loadingStatus = useSelector((state) => state.sendForm.loadingStatus);
    const error = useSelector((state) => state.sendForm.error);
    const reload = true;
    const { transformFormValues } = useTransformValues();

    useEffect(() => {
        dispatch(fetchFields({token}))
    }, [dispatch, token]);

    const adaptedFieldList = useAdaptedFields();
    const fields = adaptedFieldList.flatMap(category => category.fields);

    const { handleSubmit } = useFormSubmit({
        formId,
        onSubmit: async (formValues) => {
            const attributes = transformFormValues(formValues, fields);

            const body = {
                data: {
                    type: "report",
                    attributes: attributes
                }
            };

            console.log("Отправляемые данные", body);

            const action = await dispatch(sendForm({url: "/reports", body, token}));
            if (sendForm.fulfilled.match(action)) {
                dispatch(clearForm({formId}));
            } else {
                throw action.payload || action.error
            }
        },
        successMessage: "Успешно отправлено",
        fields,
        reload,
        error
    });

    return { formId, loadingStatus, handleSend: handleSubmit, adaptedFieldList }
}